/**
 * plugins/webfontloader.js
 *
 * webfontloader documentation: https://github.com/typekit/webfontloader
 */
export async function loadFonts() {
  const webFontLoader = await import(/* webpackChunkName: "webfontloader" */ 'webfontloader')

  webFontLoader.load({
    google: {
      families: [
        'Public+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,600&display=swap',
        'Fraunces:600,700&display=swap',
      ],
    },
  })
}

export default function () {
  loadFonts()
}
